<div
  class="sticky top-16 z-20 pb-1"
  style="background-color: var(--surface-ground)"
>
  <div
    class="border border-gray-200 dark:border-zinc-600 bg-white dark:bg-zinc-900 rounded-lg p-3 shadow-sm mb-1"
  >
    <div class="flex gap-3">
      <p-multiselect
        [(ngModel)]="selectedMaintPlants"
        [options]="maintPlants"
        optionLabel="name"
        placeholder="Division"
        [maxSelectedLabels]="2"
        selectedItemsLabel="{0} divisions"
        class="flex-1"
        [style]="{ 'font-size': '0.875rem' }"
      />
      <p-multiselect
        [(ngModel)]="selectedPlannerGroups"
        [options]="plannerGroups"
        optionLabel="name"
        placeholder="Groupe de Planification"
        [maxSelectedLabels]="2"
        selectedItemsLabel="{0} groupes"
        class="flex-1"
        [style]="{ 'font-size': '0.875rem' }"
      />
      <p-multiselect
        [(ngModel)]="selectedMainWorkCenters"
        [options]="mainWorkCenters"
        optionLabel="name"
        placeholder="Centre de Travail"
        [maxSelectedLabels]="2"
        selectedItemsLabel="{0} centres"
        class="flex-1"
        [style]="{ 'font-size': '0.875rem' }"
      />
    </div>
  </div>

  <!-- Selected Node Name Display -->


  <div
    class="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-600 rounded-lg shadow-sm overflow-hidden"
  >
    <button
      (click)="chartsCollapsed = !chartsCollapsed"
      class="w-full flex justify-between items-center p-3 hover:bg-gray-50 dark:hover:bg-zinc-800 transition-colors"
    >
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-gray-600 dark:text-zinc-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          ></path>
        </svg>
  <div
    *ngIf="selectedNode"    
  >
    <h2 class="text-lg font-semibold text-gray-800 dark:text-zinc-200">
      {{ selectedNode.label }}
    </h2>
  </div>
      </div>
      <svg
        class="w-5 h-5 text-gray-600 dark:text-zinc-400 transition-transform duration-200"
        [class.rotate-180]="!chartsCollapsed"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        ></path>
      </svg>
    </button>
    <div
      *ngIf="!chartsCollapsed"
      class="grid grid-cols-3 gap-4 p-2 border-t border-gray-200 dark:border-zinc-600"
    >
      <div
        class="bg-gradient-to-br from-slate-50 to-gray-50 dark:from-zinc-800 dark:to-zinc-900 border border-slate-200 dark:border-zinc-600 rounded-lg p-4 shadow-sm"
      >
        <div class="flex items-center gap-2 mb-3">
          <svg
            class="w-5 h-5 text-slate-600 dark:text-slate-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
            ></path>
          </svg>
          <h4 class="text-sm font-semibold text-gray-700 dark:text-zinc-300">
            Répartition des scores
          </h4>
        </div>
        <div
          *ngIf="scoresCategoriesChartData"
          class="w-full h-20"
        >
          <p-chart
            type="bar"
            [data]="scoresCategoriesChartData"
            [options]="scoresCategoriesChartOptions"
          />
        </div>
        <div
          *ngIf="!scoresCategoriesChartData"
          class="h-[11.5rem] flex items-center justify-center"
        >
          <p class="text-gray-500 dark:text-zinc-400 text-center">
            Aucune donnée disponible
          </p>
        </div>
      </div>
      <div
        class="bg-gradient-to-br from-slate-50 to-gray-50 dark:from-zinc-800 dark:to-zinc-900 border border-slate-200 dark:border-zinc-600 rounded-lg p-4 shadow-sm"
      >
        <div class="flex items-center gap-2 mb-3">
          <svg
            class="w-5 h-5 text-slate-600 dark:text-slate-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
          <h4 class="text-sm font-semibold text-gray-700 dark:text-zinc-300">
            Distribution des heures
          </h4>
        </div>
        <div *ngIf="capacityChartData" class="w-full h-50">
          <p-chart
            type="bar"
            [data]="capacityChartData"
            [options]="capacityChartOptions"
          />
        </div>
        <div
          *ngIf="!capacityChartData"
          class="h-[11.5rem] flex items-center justify-center"
        >
          <p class="text-gray-500 dark:text-zinc-400 text-center">
            Aucune donnée disponible
          </p>
        </div>
      </div>
      <div
        class="bg-gradient-to-br from-slate-50 to-gray-50 dark:from-zinc-800 dark:to-zinc-900 border border-slate-200 dark:border-zinc-600 rounded-lg p-4 shadow-sm"
      >
        <div class="flex items-center gap-2 mb-3">
          <svg
            class="w-5 h-5 text-slate-600 dark:text-slate-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
            ></path>
          </svg>
          <h4 class="text-sm font-semibold text-gray-700 dark:text-zinc-300">
            Distribution Priorité
          </h4>
        </div>
        <div *ngIf="priorityChartData" class="w-full h-50">
          <p-chart
            type="bar"
            [data]="priorityChartData"
            [options]="priorityChartOptions"
          />
        </div>
        <div
          *ngIf="!priorityChartData"
          class="h-[11.5rem] flex items-center justify-center"
        >
          <p class="text-gray-500 dark:text-zinc-400 text-center">
            Aucune donnée disponible
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<p-treetable
  [value]="hierarchyNodes"
  [scrollable]="false"
  [loading]="loading"
  selectionMode="single"
  [(selection)]="selectedNode"
>
  <ng-template pTemplate="colgroup">
    <colgroup>
      <col style="width: 38%" />
      <col style="width: 8%" />
      <col style="width: 5%" />
      <col style="width: 8%" />
      <col style="width: 5%" />
      <col style="width: 7%" />
      <col style="width: 6%" />
      <col style="width: 7%" />
      <col style="width: 8%" />
      <col style="width: 8%" />
    </colgroup>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th class="text-center">Nom</th>
      <th class="text-center">Score</th>
      <th class="text-center">Catégorie</th>
      <th class="text-center">Statut utilisateur</th>
      <th class="text-center">Priorité</th>
      <th class="text-center">Date d'échéance</th>
      <th class="text-center">Sem. Retard</th>
      <th class="text-center">Hrs. Engagées</th>
      <th class="text-center">Hrs. Non-Engagées</th>
      <th class="text-center">Statut</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
    <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
      <!-- Regular nodes (Parent/Hierarchy) -->
      <ng-container *ngIf="!rowData.type">
        <td>
          <div
            class="flex items-center gap-2"
            [style.padding-left.px]="rowNode.level * 24"
          >
            <p-treeTableToggler [rowNode]="rowNode" />
            <span [style.font-weight]="Math.max(350, 600 - rowNode.level * 50)">
              <ng-container
                *ngIf="rowData.ObjectType !== 'Room'; else nameOnly"
              >
                {{ rowData.Id }} - {{ rowData.Name }}
              </ng-container>
              <ng-template #nameOnly>{{ rowData.Name }}</ng-template>
            </span>
            <span
              *ngIf="rowNode.node.children?.length > 0"
              class="inline-flex items-center justify-center ml-1 min-w-[1.25rem] h-5 px-1.5 text-xs leading-none rounded bg-gray-200 dark:bg-zinc-700 text-gray-600 dark:text-gray-400"
            >
              {{ rowNode.node.children.length }}
            </span>
          </div>
        </td>
        <td class="text-center">
          <div class="flex items-center gap-2">
            <div
              class="flex-1 h-2 bg-neutral-200 dark:bg-neutral-800 rounded-full overflow-hidden"
            >
              <div
                class="h-full rounded-full transition-all duration-1000 ease-out bg-gradient-to-r"
                [ngClass]="getScoreColor(rowData.Score)"
                [style.width.%]="
                  rowData.Score > 0 ? (rowData.Score / 100) * 100 : 0
                "
              ></div>
            </div>
            <div class="text-sm font-semibold min-w-[4rem] text-left">
              {{ rowData.Score | number : "1.0-2" }}
            </div>
          </div>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-center">
          {{ rowData.ReleasedHours || "-" }}
        </td>
        <td class="text-center">
          {{ rowData.NonReleasedHours || "-" }}
        </td>
        <td></td>
      </ng-container>

      <!-- ReleasedWorkOrders (Child) -->
      <ng-container *ngIf="rowData.type === 'ReleasedWorkOrder'">
        <td>
          <div
            class="flex items-center gap-2"
            [style.padding-left.px]="(rowNode.level + 1) * 30"
          >
            <span class="text-gray-700 dark:text-gray-300">
              {{ rowData.WorkOrder?.SAP_WorkOrderId }} -
              {{ rowData.WorkOrder?.SAP_Description }}
            </span>
          </div>
        </td>
        <td class="text-center">
          <div class="flex items-center gap-2">
            <div
              class="flex-1 h-2 bg-neutral-200 dark:bg-neutral-800 rounded-full overflow-hidden"
            >
              <div
                class="h-full rounded-full transition-all duration-1000 ease-out bg-gradient-to-r"
                [ngClass]="getScoreColor(rowData.Score)"
                [style.width.%]="
                  rowData.Score > 0 ? (rowData.Score / 100) * 100 : 0
                "
              ></div>
            </div>
            <div class="text-sm font-semibold min-w-[4rem] text-left">
              {{ rowData.Score | number : "1.0-2" }}
            </div>
          </div>
        </td>
        <td class="text-center">
          <span
            class="px-3.5 py-1 rounded-full text-sm font-semibold bg-gray-400 text-white"
          >
            {{ rowData.WorkOrder?.SAP_WorkOrderType || "-" }}
          </span>
        </td>
        <td class="text-center">
          <span
            class="px-4 py-1.5 rounded-full text-sm font-semibold text-white"
            [ngClass]="getUserStatusClass(rowData.WorkOrder?.UserStatus)"
          >
            {{ rowData.WorkOrder?.UserStatus || "-" }}
          </span>
        </td>
        <td class="text-center">
          <span
            class="inline-flex items-center justify-center w-7 h-7 rounded-full text-white text-sm font-semibold"
            [ngClass]="getPriorityColor(rowData.WorkOrder?.SAP_Priority)"
          >
            {{ rowData.WorkOrder?.SAP_Priority }}
          </span>
        </td>
        <td class="text-center">
          <span
            *ngIf="
              isOverdue(rowData.WorkOrder?.SAP_OriginalDueDate);
              else normalDate
            "
            class="px-3 py-1 rounded-full text-sm font-semibold bg-red-500 text-white"
          >
            {{ rowData.WorkOrder?.SAP_OriginalDueDate | date : "yyyy/MM/dd" }}
          </span>
          <ng-template #normalDate>
            {{ rowData.WorkOrder?.SAP_OriginalDueDate | date : "yyyy/MM/dd" }}
          </ng-template>
        </td>
        <td class="text-center">
          {{ getWeeksOverdue(rowData.WorkOrder?.SAP_OriginalDueDate) }}
        </td>
        <td class="text-center">
          {{ rowData.TotalWorkHours || "-" }}
        </td>
        <td class="text-center">-</td>
        <td class="text-center">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-full bg-green-500"></div>
            <span class="text-sm font-medium">Engagé</span>
          </div>
        </td>
      </ng-container>

      <!-- NotReleasedWorkOrders (Child) -->
      <ng-container *ngIf="rowData.type === 'NotReleasedWorkOrder'">
        <td>
          <div
            class="flex items-center gap-2"
            [style.padding-left.px]="(rowNode.level + 1) * 30"
          >
            <span class="text-gray-700 dark:text-gray-300">
              {{ rowData.WorkOrder?.SAP_WorkOrderId }} -
              {{ rowData.WorkOrder?.SAP_Description }}
            </span>
          </div>
        </td>
        <td class="text-center">
          <div class="flex items-center gap-2">
            <div
              class="flex-1 h-2 bg-neutral-200 dark:bg-neutral-800 rounded-full overflow-hidden"
            >
              <div
                class="h-full rounded-full transition-all duration-1000 ease-out bg-gradient-to-r"
                [ngClass]="getScoreColor(rowData.Score)"
                [style.width.%]="
                  rowData.Score > 0 ? (rowData.Score / 100) * 100 : 0
                "
              ></div>
            </div>
            <div class="text-sm font-semibold min-w-[4rem] text-left">
              {{ rowData.Score | number : "1.0-2" }}
            </div>
          </div>
        </td>
        <td class="text-center">
          <span
            class="px-3.5 py-1 rounded-full text-sm font-semibold bg-gray-400 text-white"
          >
            {{ rowData.WorkOrder?.SAP_WorkOrderType || "-" }}
          </span>
        </td>
        <td class="text-center">
          <span
            class="px-4 py-1.5 rounded-full text-sm font-semibold text-white"
            [ngClass]="getUserStatusClass(rowData.WorkOrder?.UserStatus)"
          >
            {{ rowData.WorkOrder?.UserStatus || "-" }}
          </span>
        </td>
        <td class="text-center">
          <span
            class="inline-flex items-center justify-center w-7 h-7 rounded-full text-white text-sm font-semibold"
            [ngClass]="getPriorityColor(rowData.WorkOrder?.SAP_Priority)"
          >
            {{ rowData.WorkOrder?.SAP_Priority }}
          </span>
        </td>
        <td class="text-center">
          <span
            *ngIf="
              isOverdue(rowData.WorkOrder?.SAP_OriginalDueDate);
              else normalDate2
            "
            class="px-3 py-1 rounded-full text-sm font-semibold bg-red-500 text-white"
          >
            {{ rowData.WorkOrder?.SAP_OriginalDueDate | date : "yyyy/MM/dd" }}
          </span>
          <ng-template #normalDate2>
            {{ rowData.WorkOrder?.SAP_OriginalDueDate | date : "yyyy/MM/dd" }}
          </ng-template>
        </td>
        <td class="text-center">
          {{ getWeeksOverdue(rowData.WorkOrder?.SAP_OriginalDueDate) }}
        </td>
        <td class="text-center">-</td>
        <td class="text-center">
          {{ rowData.TotalWorkHours || "-" }}
        </td>
        <td class="text-center">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-full bg-orange-500"></div>
            <span class="text-sm font-medium">Non engagé</span>
          </div>
        </td>
      </ng-container>
    </tr>
  </ng-template>
</p-treetable>
